module.exports = __webpack_public_path__ + "05529d5925250c3d9b2b5fffef970595.png";